// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles_arrow__2lCQb","tooltip":"styles_tooltip__otgLB","tooltipBody":"styles_tooltipBody__uHBwM"};